var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"mdn-Spinner"},[_c('v-progress-circular',{attrs:{"indeterminate":"","color":"white"}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }